
type AngularUnits = {
  deg: string | undefined;
  dms: string | undefined;
  rad: string | undefined;
  mrad: string | undefined;
}


export type AngleConversionState = {
  angle: AngularUnits;
};

// Reducer
type ConversionCategory = keyof Pick<
  AngleConversionState,
  'angle'
>;

type UpdateUnitAction = {
  type: 'update_unit';
  payload: {
    category: ConversionCategory;
    updatedUnits: Record<string, string>; // contains both the input and converted unit(s)
  };
};

type ResetCategoryAction = {
  type: 'reset_category';
  payload: {
    category: ConversionCategory;
  };
};

type ConversionAction =
  | UpdateUnitAction
  | ResetCategoryAction;


export const angleConversionInitialState: AngleConversionState = {
  angle: { deg: undefined, dms: undefined, rad: undefined, mrad: undefined }
};


export const angleConversionReducer = (
  state: AngleConversionState,
  action: ConversionAction
): AngleConversionState => {
  switch (action.type) {
    case 'update_unit': {
      const { category, updatedUnits } = action.payload;

      return {
        ...state,
        [category]: {
          ...state[category],
          ...updatedUnits,
        },
      };
    }

    case 'reset_category': {
      const { category } = action.payload;
      const resetCategoryState = Object.keys(state[category]).reduce((acc, key) => {
        acc[key] = undefined;
        return acc;
      }, {} as AngularUnits);

      return {
        ...state,
        [category]: resetCategoryState,
      };
    }

    default:
      return state;
  }
};
